import { render, staticRenderFns } from "./BaseInfobox.vue?vue&type=template&id=60331733&scoped=true&"
import script from "./BaseInfobox.vue?vue&type=script&lang=ts&"
export * from "./BaseInfobox.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInfobox.vue?vue&type=style&index=0&id=60331733&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60331733",
  null
  
)

export default component.exports